<template>
  <div class="activity">
    <div class="search_box">
      <top-title classType="1" :name="'活动码'"></top-title>
      <div style="margin:20px 0">
        <input-form ref="inputForm" @toParentVal="getActivityCodeConfig" :inputData="inputData"></input-form>
      </div>
    </div>
    <div class="tab_box">
      <div>
        <span class="create_btn3" @click="newBtn()">
          <img
            src="@/assets/images/member/new_establish.png"
            style="
             display: inline-block;
             float: left;
             width: 14px;
             height: 14px;
             color: #ffffff;
             margin: 9px -6px 0px 12px"
          />
          创建活动
        </span>
      </div>

      <!-- 表格 -->
      <div class="clear-float">
        <el-table
          :data="tableList"
          style="width: 100%;margin-top: 22px;"
          :header-cell-style="{background:'#fafafa'}"
          v-loading="tableLoading"
        >
          <el-table-column prop="activityName" label="活动名称"></el-table-column>
          <el-table-column prop="activityTime" label="活动时间">
            <template slot-scope="scope">
              <span v-if="scope.row.persistentOpenFlag">持续开启</span>
              <template v-else>
                <span>{{scope.row.activityTimeStart}}</span>
                <span>至</span>
                <span>{{scope.row.activityTimeEnd}}</span>
              </template>
            </template>
          </el-table-column>
          <el-table-column label="活动码使用数据" width="180">
            <template slot-scope="scope">
              <div>总数：{{scope.row.activityCodeNum}}</div>
              <div>已使用：{{scope.row.activityTimeUsed}}</div>
              <div>未使用：{{scope.row.activityTimeRest}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间" width="180"></el-table-column>
          <el-table-column prop="updateTime" label="最后修改时间" width="180"></el-table-column>
          <el-table-column label="活动状态" width="90">
            <template slot-scope="scope">
              <span>{{ scope.row.status | statusStr }}</span>
            </template>
          </el-table-column>
          <el-table-column label="开启状态" width="100">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.isOpen"
                :active-value=1
                active-color="#49C568"
                :inactive-value=0
                @change="changeSwitch(scope.row)"
              ></el-switch>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="210">
            <template slot-scope="scope">
              <template v-if="scope.row.status!=0">
                <el-button
                  @click="recordOrderCare(scope.row)"
                  size="mini"
                  type="text"
                  class="edit_btn btn"
                >发送记录</el-button>
              </template>
              <template v-if="scope.row.status!=1">
                <el-button
                  @click="deleteOrderCare(scope.row)"
                  size="mini"
                  type="text"
                  class="del_btn btn"
                >删除</el-button>
              </template>
              <template v-if="scope.row.status!=2">
                <el-button
                  @click="reviseOrderCare(scope.row)"
                  size="mini"
                  type="text"
                  class="edit_btn btn"
                >修改</el-button>
              </template>
              <template v-if="scope.row.status!=2">
                <el-button
                  @click="statusOrderCare(scope.row,0)"
                  size="mini"
                  type="text"
                  class="del_btn btn"
                >结束</el-button>
              </template>
            </template>
          </el-table-column>
        </el-table>
        <pagination @transferName="smsPaginationFunction" :total="activityTableTotalCount"></pagination>
      </div>
    </div>

    <el-dialog
      title="发送记录"
      :visible.sync="smsDialog"
      width="1350px"
      :open="handleOpen"
      :before-close="noneBtn"
    >
      <el-form v-model="smsSearch" label-width="90px">
        <el-row>
          <el-col :span="5">
            <el-form-item label="手机号：">
              <el-input v-model="smsSearch.mobile"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="9">
            <el-form-item label="发送时间：">
              <el-date-picker
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="选择日期"
                :picker-options="pickerOptions0"
                v-model="smsSearch.sendTimeStart"
                style="width: 45%;"
              ></el-date-picker>
              <span> 至 </span>
              <el-date-picker
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="选择日期"
                :picker-options="pickerOptions1"
                v-model="smsSearch.sendTimeEnd"
                style="width: 45%;"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="发送状态：">
              <el-select v-model="smsSearch.status">
                <el-option label="全部" value></el-option>
                <el-option label="未发送" value="0"></el-option>
                <el-option label="已发送" value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item>
              <el-button @click="fetchActivityCodeSmsrecord" type="primary">查询</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-table
        :data="recordList"
        style="width: 100%;margin-top: 22px;"
        :header-cell-style="{background:'#fafafa'}"
        v-loading="smsRecordLoading"
      >
        <el-table-column prop="mobile" label="发送号码" width="120"></el-table-column>
        <el-table-column prop="sendTime" label="发送时间" width="200"></el-table-column>
        <el-table-column prop="smsNumber" label="计费条数" width="80"></el-table-column>
        <el-table-column prop="status" label="状态" width="120"></el-table-column>
        <el-table-column prop="content" label="短信内容" >
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              effect="light"
              :content="scope.row.content"
              placement="top"
            >
              <div class="hoveTitle" v-show="!scope.row.allShow">
                {{ scope.row.content }}
              </div>
            </el-tooltip>
            <div class="hoveTitleShowMore" v-show="scope.row.allShow">
              {{ scope.row.content }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120">
          <template slot-scope="scope">
            <el-button v-show="!scope.row.allShow" @click="showInfo(true,scope.row.id)" size="mini" type="text" class="del_btn btn">展开</el-button>
            <el-button v-show="scope.row.allShow" @click="showInfo(false,scope.row.id)" style="margin-left:0" size="mini" type="text" class=" btn">单行</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination @transferName="recordPaginationFunction" :total="recordTotalCount"></pagination>
      <!-- <div style="padding: 20px 28px 30px;text-align: right;margin-bottom: 0px;">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :page-sizes="[10,50,100,500,1000]"
          :total="recordTotalCount"
          :page-size="smsSearch.size"
          :current-page="smsSearch.current"
          @size-change="handleSizeChangeSms"
          @current-change="handleCurrentChangeSms"
        ></el-pagination>
      </div> -->
    </el-dialog>
    <!-- 新建任务 pageConditionCom  -->
    <page-condition
      v-if="pageConditionCom"
      :isAdd="isAdd"
      :postForms="detailFormData"
      :menuType="menuIndex"
      :scorllY="topPX"
      :isShowTip="true"
      :bodyHeight="bodyHeight"
      @transferName="conditionBtnNone()"
      :drawer="true"
    ></page-condition>
  </div>
</template>
<script>
import {
  getActivityCodeConfig,
  getInfo,
  deleteActivity,
  activitySwitch,
  getActivityCodeSmsrecord,
} from "@/api/activity";
import pageCondition from "./page-condition.vue";
import TopTitle from "@/components/top-title.vue";
import Pagination from "@/components/pagination.vue";
import InputForm from "@/components/inputForm.vue";
import { mapState } from "vuex";
export default {
  components: {
    TopTitle,
    Pagination,
    InputForm,
    pageCondition,
  },
  data() {
    return {
      tableLoading: false,
      smsRecordLoading: false,
      pageConditionCom: false,
      detailFormData: null,
      smsDialog: false,
      topPX: "60px",
      bodyHeight: 0,
      isAdd: true,
      pickerOptions0: {
        disabledDate: (time) => {
          if (!this.smsSearch.sendTimeEnd) {
            return time.getTime() > Date.now() - 8.64e7;
          } else {
            let endTime = new Date(this.smsSearch.sendTimeEnd).getTime();
            // 最小选择时间   (时间跨度不能大于一年时间)
            let minTime = endTime - 365 * 24 * 3600 * 1000;

            return (
              time.getTime() < minTime || time.getTime() > Date.now() - 8.64e7
            );
          }
        },
      },
      pickerOptions1: {
        disabledDate: (time) => {
          if (!this.smsSearch.sendTimeStart) {
            return time.getTime() > Date.now() - 8.64e7;
          } else {
            let startTime = new Date(this.smsSearch.sendTimeStart).getTime();
            // 最大选择时间  （时间跨度不能大于一年）
            let maxTime = startTime + 365 * 24 * 3600 * 1000;

            return (
              time.getTime() < startTime ||
              time.getTime() > Date.now() - 8.64e7 ||
              time.getTime() > maxTime - 8.64e7
            );
          }
        },
      },
      PaginationForm: {
        current: 1,
        size: 10,
      },
      PaginationForm: {
        current: 1,
        size: 10,
      },
      activityTableTotalCount: 0,
      recordTotalCount: 0,
      smsSearch: {
        current: 1,
        size: 10,
        mobile: "",
        sendTimeStart: "",
        sendTimeEnd: "",
        status: "1",
      },
      recordList: [
        // {
        //   comfrom: "宝洁海飞丝",
        //   content: "海飞丝王一博见面会抽奖码：WYB101，敬请您关注后续抽奖情况。",
        //   id: 75,
        //   mobile: "181****8090",
        //   sellerNick: "Walmart-JD",
        //   sendTime: "2019-10-23 23:14:02",
        //   smsNumber: 1,
        //   status: 1,
        //   subTime: "2019-10-23 23:14:02",
        //   allShow:false
        // },
        // {
        //   comfrom: "宝洁海飞丝",
        //   content: "【沃尔玛京东自营官方旗舰店】海飞丝王一博见面会抽奖码：WYB101，敬请您关注后续抽奖情况。WYB101，敬请您关注后续抽奖情况。WYB101，敬请您关注后续抽奖情况。",
        //   id: 85,
        //   mobile: "181****8090",
        //   sellerNick: "Walmart-JD",
        //   sendTime: "2019-10-23 23:14:02",
        //   smsNumber: 1,
        //   status: 1,
        //   subTime: "2019-10-23 23:14:02",
        //   allShow:true
        // },
        // {
        //   comfrom: "宝洁海飞丝",
        //   content: "【沃尔玛京东自营官方旗舰店】海飞丝王一博见面会抽奖码：WYB101，敬请您关注后续抽奖情况。",
        //   id: 75,
        //   mobile: "181****8090",
        //   sellerNick: "Walmart-JD",
        //   sendTime: "2019-10-23 23:14:02",
        //   smsNumber: 1,
        //   status: 1,
        //   subTime: "2019-10-23 23:14:02",
        //   allShow:false
        // },
      ],
      inputData: [
        {
          name: "活动名称:",
          val: "activityName",
          placeholder: "请输入活动名称",
        },
        {
          name: "活动时间:",
          myDate: true,
          val: ["activityTimeStart", "activityTimeEnd"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
        {
          name: "活动状态:",
          width: 180,
          val: "status",
          selectArr: [
            { id: "", label: "全部" },
            { id: 0, label: "未开始" },
            { id: 1, label: "进行中" },
            { id: 2, label: "已结束" },
          ],
        },
        {
          name: "开启状态:",
          width: 180,
          val: "isOpen",
          selectArr: [
            { id: "", label: "全部" },
            { id: 0, label: "开启" },
            { id: 1, label: "关闭" },
          ],
        },
      ],
      tableList: [
        {
          activityName: "活动1",
          activityTime: "持续开始",
          createdTime: "2020-06-16 15:46:50",
          activityData: {
            total: 900,
            alreadyUse: 900,
            notUse: 0,
          },
          activityType: "0",
        },
      ],
    };
  },
  mounted() {
    this.$refs.inputForm.formSearch();
  },
  computed: {
    // 获取定义在路由meta的信息
    taskTypeActive() {
      return this.$route.meta.taskType;
    },
    tittle() {
      return this.$route.name;
    },
    ...mapState({
      changeColor: "globalBG",
      //   把city映射给currentCIty
    }),
    menuIndex() {
      return this.$route.meta.itemIndex;
    },
  },
  methods: {
    showInfo(state,id){
      this.recordList.filter(i=>{
        // console.log(id,i.id);
        if(id==i.id){
          i.allShow = state
        }
      })
    },
    // 查询活动
    getActivityCodeConfig(form) {
      this.tableLoading = true;
      getActivityCodeConfig({
        ...form,
        ...this.PaginationForm,
      }).then(({ data }) => {
        this.tableLoading = false;
        this.tableList = data.records;
        this.activityTableTotalCount = data.total;
      });
    },
    // 创建任务
    newBtn() {
      console.log("新建任务==");
      // 设置回显数据为空
      this.detailFormData = null;
      const height =
        document.documentElement.clientHeight || document.body.clientHeight;
      if (this.topPX == "60px") {
        this.bodyHeight = height - 60;
      } else {
        this.bodyHeight = height - 60;
      }
      this.pageConditionCom = true;
      // switch (this.changeNick) {
      //   case "下单关怀":
      //     this.conditionState = 1;
      //     break;
      //   case "拒绝退款":
      //     this.conditionState = 23;
      //     break;
      //   case "退款成功":
      //     this.conditionState = 24;
      //     break;
      // }
    },
    // 删除任务
    deleteOrderCare(item) {
      console.log(item);
      if (item.isOpen == 1) {
        this.$message.warning("开启状态的任务不可删除！");
        return;
      }
      this.$confirm("是否确认删除任务？", "提示", {
        distinguishCancelAndClose: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
       iconClass:"iconfont iconicon-jinggao1",
      })
        .then(() => {
          deleteActivity(item.id).then((res) => {
            res.code === 1
              ? (this.$message.success("操作成功"),
                this.$refs.inputForm.formSearch())
              : this.$message.error(res.message);
          });
        })
        .catch((action) => {});
    },
    // 任务开启状态改变
    changeSwitch(val){
      let params = {
        id: val.id,
        isOpen: val.isOpen,
        isThread:1
      }
      activitySwitch(params).then((res) => {
        if (res.code == 1) {
          this.$message.success(res.message);
          this.$refs.inputForm.formSearch();
        }
      });
    },
    //修改任务
    reviseOrderCare(item) {
      getInfo({ id: item.id }).then((res) => {
        console.log(res);
        //列表字符串转对象 回显
        let data = res.data;
        this.detailFormData = {
          taskName: data.activityName,
          taskStartTime: data.activityTimeStart,
          taskType:data.persistentOpenFlag?0:1,
          taskEndTime: data.activityTimeEnd,
          startRemindTime: data.activitySendTimeStart + ":00",
          endRemindTime: data.activitySendTimeEnd + ":00",
          activityCodeNum: data.activityCodeNum,
          activitySendTimeType: data.sendTimeType + "",
          isLunchBreak: data.filterSendType == 1 ? true : false,
          startLunchBreak:data.filterSendTimeStart==null?"12:00": data.filterSendTimeStart + ":00",
          endLunchBreak: data.filterSendTimeEnd==null?"13:00": data.filterSendTimeEnd+ ":00",
          isOrderMoney: data.orderMoneyFilterType == 1 ? true : false,
          startOrderMoney: data.orderMoneyStart,
          endOrderMoney: data.orderMoneyEnd,
          payType:
            data.payTypeFilterData == 0 || data.payTypeFilterData == null
              ? []
              : data.payTypeFilterData.split(","),
          filterCondition: [],
          isAllItem: data.filterWareType + "",
          itemList:data.activityCodeWareVoList,
          areaType: data.appointAreaType==1?"3":"0",
          zip:data.appointAreas,
          participationNumber: "",
          startProductNum:data.wareNumberStart,
          endProductNum:data.wareNumberEnd,
          isProductNum:data.wareNumberConfigType==1?true:false,
          id: data.id,
          content: data.content,
          suffix: data.suffix,
          idOpen: data.isOpen,
        };
        // return
        data.customerType.split(",").map((item) => {
          if (item == 1) {
            this.detailFormData.filterCondition.push("2");
          }
          if (item == 2) {
            this.detailFormData.filterCondition.push("3");
          }
          if (item == 3) {
            this.detailFormData.filterCondition.push("1");
          }
        });
        console.log(data.customerType.split(","));

        if (data.participationType == 1) {
          this.detailFormData.filterCondition.push("4");
          this.detailFormData.participationNumber = data.participationNumber;
        }
        const height =
          document.documentElement.clientHeight || document.body.clientHeight;
        if (this.topPX == "60px") {
          this.bodyHeight = height - 60;
        } else {
          this.bodyHeight = height - 60;
        }
        this.pageConditionCom = true;
        this.isAdd = false;
      });
    },
    statusOrderCare(item, status) {
      activitySwitch({
        id: item.id,
        isOpen: status,
      }).then((res) => {
        if (res.code == 1) {
          this.$message.success(res.message);
          this.$refs.inputForm.formSearch();
        }
      });
    },
    // 分页事件
    smsPaginationFunction(event) {
      this.PaginationForm.current = event.current;
      this.PaginationForm.size = event.pageSize;
      this.$refs.inputForm.formSearch();
    },
    //短信记录分页事件
    recordPaginationFunction(event) {
      this.smsSearch.size = event.pageSize;
      this.smsSearch.current = event.current;
      this.fetchActivityCodeSmsrecord()
    },
    conditionBtnNone() {
      this.$refs.inputForm.formSearch();
      // this.paginationInfo.tableCurrentPage = 1;
      setTimeout(() => {
        this.pageConditionCom = false;
        this.isAdd = true;
      }, 500);
    },
    // 查询发送记录
    recordOrderCare(item) {
      this.smsDialog = true;
      this.smsSearch.activityCodeConfigId = item.id;
      this.fetchActivityCodeSmsrecord();
    },

    fetchActivityCodeSmsrecord() {
      this.smsRecordLoading = true;
      let params = this.smsSearch
      for(var i in params){
        if(params[i]==''){
            delete params[i]
        }
      }
      getActivityCodeSmsrecord(params).then(({ data }) => {
        data.records.map(i=>{i.allShow=false})
        this.recordList = data.records;
        this.recordTotalCount = data.total;
        this.smsRecordLoading = false;
      });
    },
    handleOpen() {
      // getActivityCodeSmsrecord()
    },
    noneBtn(done) {
      done();
    },
  },
  filters: {
    statusStr(status) {
      return {
        0: "未开始",
        1: "进行中",
        2: "已结束",
      }[status];
    },
  },
};
</script>

<style lang='scss' scoped>
.activity {
  .hoveTitle {
    text-align: left;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .hoveTitleShowMore {
    white-space: normal;
  }
  .search_box {
    // padding:0 25px 25px 30px;
    margin: 20px;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    overflow: hidden;
    background: #fff;
  }
  .tab_box {
    padding: 20px 25px 30px;
    margin: 20px;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    background: #fff;

    .create_btn3 {
      width: 98px;
      height: 32px;
      opacity: 1;
      border-radius: 3px;
      display: inline-block;
      text-align: center;
      line-height: 32px;
      font-size: 14px;
      /* font-family: PingFang SC; */
      font-weight: 400;
      cursor: pointer;
      color: #ffffff;
      background-color: #fe4d45;
      &:hover {
        color: #fff;
        opacity: 0.9;
        background-color: #fe4d45;
      }
    }
    .btn {
      width: 60px;
      float: right;
      padding: 0px !important;
    }
    .edit_btn {
      font-size: 14px;
      border: 0px;
      height: 20px;
      line-height: 20px;
      margin: 0px;
       cursor: pointer;
        color: #7f85e9;
        &:hover {
          color: #fe4d45;
        }
    }
    .del_btn {
      font-size: 14px;
      border: 0px;
      height: 20px;
      line-height: 20px;
      margin-left: 0px;
       cursor: pointer;
        color: #7f85e9;
        &:hover {
          color: #fe4d45;
        }
    }
  }
}
</style>